import { UserAttributes } from '@builder.io/sdk-react/types/helpers/user-attributes';
import { FC } from 'react';
import { useBuilderIoTabs } from '../BuilderIoTabs/BuilderIoTabsProvider';

export const BuilderIoTabInputs = [
  {
    type: 'number',
    name: 'tabId',
    required: true,
  },
];

export type BuilderIoTab = {
  tabId: number;
  children: JSX.Element;
} & UserAttributes;

export const BuilderIoTab: FC<BuilderIoTab> = ({ children, tabId }) => {
  const { activeTab } = useBuilderIoTabs();

  if (activeTab !== tabId) return null;
  return <div>{children}</div>;
};
